// Implements: F-GEN-033, F-GEN-034
/**
 * Where one diagram of one version stands (mockup v3 P6, C6.3): `ready` when the version holds
 * that kind's artifact (`diagram` for the journey, `diagram_walkthrough` for the walkthrough),
 * `drawing` while this screen draws it, `none` otherwise. The stored artifact wins: what the
 * server holds is the truth, whatever this screen believes it is doing.
 */

import type { ArtifactRef } from "../../../types/api";
import { ARTIFACT_OF_KIND } from "../../../types/diagrams";
import type { DiagramKind } from "../../../types/diagrams";

export type DiagramPaneState = "ready" | "none" | "drawing";

export function diagramStateOf(
  artifacts: readonly ArtifactRef[],
  kind: DiagramKind,
  local: "idle" | "drawing",
): DiagramPaneState {
  if (artifacts.some((piece) => piece.kind === ARTIFACT_OF_KIND[kind])) return "ready";
  return local === "drawing" ? "drawing" : "none";
}
